var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50009 16.125C7.50007 16.7463 8.00374 17.25 8.62506 17.25C9.24638 17.25 9.75007 16.7463 9.75009 16.125L9.75024 9.75012L16.1255 9.75C16.7468 9.74999 17.2505 9.2463 17.2505 8.62498C17.2504 8.00366 16.7467 7.49999 16.1254 7.5L9.7503 7.50012L9.75045 1.12503C9.75047 0.503708 9.2468 1.52202e-05 8.62548 3.42467e-10C8.00416 -1.51648e-05 7.50047 0.503653 7.50045 1.12497L7.5003 7.50016L1.12498 7.50029C0.503659 7.5003 -1.13997e-05 8.00399 1.93552e-10 8.62531C1.23411e-05 9.24663 0.503701 9.7503 1.12502 9.75029L7.50024 9.75016L7.50009 16.125Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.eb30bb3e26e51a815d0819b1348b2d30.svg";
export { ForwardRef as ReactComponent };